import cx from 'clsx';
import React, { FunctionComponent } from 'react';
import styles from './DesktopNavigation.module.scss';
import { HeaderBottom } from 'components/presentional';
import { HeaderTop } from 'components/presentional';
import { WPMenu } from 'types/menus';
import { Block, BlockContent } from 'components/elements';

interface OwnProps {
  topMenu?: WPMenu | null;
  mainMenu?: WPMenu | null;
}

type DesktopNavigationProps = Omit<JSX.IntrinsicElements['div'], 'menu'> & OwnProps;

const DesktopNavigation: FunctionComponent<DesktopNavigationProps> = props => {
  const { topMenu, mainMenu, className, ...rest } = props;

  const wrapperClassName = cx({
    [styles.wrapper]: true,
    ...(className && { [className]: true }),
  });

  return (
    <div className={wrapperClassName} {...rest}>
      <Block width="container" theme="dark">
        <BlockContent>
          <HeaderTop role="navigation" aria-label="Header menu" menu={topMenu} />
        </BlockContent>
      </Block>
      <Block width="container" theme="light">
        <BlockContent>
          <HeaderBottom menu={mainMenu} />
        </BlockContent>
      </Block>
    </div>
  );
};

export default DesktopNavigation;
